<h2 mat-dialog-title>Download Withheld</h2>
<mat-dialog-content style="margin-top: 20px;">
  <div *ngIf="!isDownloadStarted">
    Download Withheld Files: {{ productionJob.title }}?
  </div>
  <div *ngIf="isDownloadStarted">
    Files are being prepared and will begin downloading shortly.
    <br />
    Depending on the size of the files this could take several minutes.
  </div>
  <mat-spinner *ngIf="isDownloadStarted" [diameter]="35" color="accent" style="margin-top: 10%;"></mat-spinner>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="download()" style="min-width:95px;" [disabled]="isDownloadStarted">Download</button>
  <button mat-raised-button color="secondary" mat-dialog-close [disabled]="isDownloadStarted">Cancel</button>
</mat-dialog-actions>
